import { Button, Card, Popconfirm, Table, Tag, notification } from 'antd';
import moment from "moment";
import React, { useState } from 'react';
import { BiSolidErrorAlt } from "react-icons/bi";
import { FaCheckCircle } from "react-icons/fa";
import { HiMiniQueueList } from "react-icons/hi2";
import { MdSync } from "react-icons/md";
import { Link } from "react-router-dom";

import { useImageProcessList, useImageReProcess, useProcessRemaingCount, useRemoveErrorImg } from '../../../requests/products';


const ImageProcessReport = () => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(30)
    const { data, isLoading }  = useImageProcessList({ page, limit });
    const { mutate } = useImageReProcess();
    const { mutate: removeMutation } = useRemoveErrorImg();
  
    const { data:remaingData } = useProcessRemaingCount();
  
  
    function removeImg({ id }){
      removeMutation({ id }, {
        onSuccess: (data) => {
          notification.info({
            message: 'Removed from queue',
            description: '',
            duration: 2,
            placement: 'topRight',
          })
        },
        onError: (error) => {
          notification.error({
            message: `Error: ${error?.message} `,
            description: '',
            duration: 2,
            placement: 'topRight',
          })
        }
      })
    }
  
  
    function reProcessImage(id){
  
      mutate({ id }, {
        onSuccess: (data) => {
          notification.info({
            message: 'Image Re-Processed Started',
            description: '',
            duration: 2,
            placement: 'topRight',
          })
        },
        onError: (error) => {
          notification.error({
            message: `Error: ${error?.message} `,
            description: '',
            duration: 2,
            placement: 'topRight',
          })
        }
      })
    }
  
    // Convert time to Asia/Dhaka
    function convertTime(time_date){
      var d = new Date(time_date);
      var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
      var nd = new Date(utc + (3600000 * 6));
      return nd;
    }
  
  
    
    const columns = [
      {
        title: 'SKU',
        dataIndex: 'prod_id',
        key: 'prod_id',
        render: prod_id => <Link to={`/product/detail/${prod_id}`}> <Tag color='#333'>{prod_id}</Tag> </Link>
      },
      {
        title: 'Date Time',
        dataIndex: '_date',
        key: '_date',
        render: date => <>{moment(convertTime(date)).format('DD/MM/YYYY h:mm:ss A')}</>
      },
      {
        title: 'Image',
        dataIndex: 'image',
        key: 'image',
        render: image => <div>
          <a target='_blank' href={image}> <img src={image} alt="prod img" width={30} height={30} /> </a>
        </div>
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status, row) => <>{
          status==='success'
          ? <FaCheckCircle color='green' size={25} />
          :  status==='queued' ? <HiMiniQueueList color='#333' size={25} /> 
            :  status==='processing' ? <MdSync className='spin' color='#ff0000' size={25} /> 
            :  <><BiSolidErrorAlt color='red' size={25} /> <Tag>{row?.err_reason}</Tag> </>
          }</>
      },
  
      {
        title: 'Action',
        dataIndex: 'image',
        key: 'image',
        render: (_, row ) => row?.status == "processing" || row?.status == "error"
        ?<>
          <Button onClick={() => reProcessImage(row?._id)}>Re-process</Button> 
          <Popconfirm title="Are you sure ?" onConfirm={e => removeImg({id: row?._id})}><Button color='red'>X</Button> </Popconfirm>
        </>
        : ""
      },
    ];
  
  
    return (
      <>
          <Card 
          title="Image Process Report" 
          extra={[
            // <Tag key={'toda-processed'} color='#333'>Today Processed: {todayData?.count ?? 0}</Tag>,
            <Tag key={'remaining-count'} color='#333'>Remaining: {remaingData?.count ?? 0}</Tag>
          ]}
          >
            <Table 
              loading={isLoading}
              dataSource={data?.queues ?? []} 
              size='small' 
              columns={columns} 
              pagination={{
                showSizeChanger:true,
                pageSize: limit,
                defaultPageSize: limit,
                total: data?.totalItems ??  0, 
                onChange: (e, size) => {
                  setPage(e);
                  setLimit(size);
                }
              }} 
            />
          </Card>
      </>
    );
  
  
    
}

export default ImageProcessReport